import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule()
export class IconsModule {
  /**
   * Constructor
   */
  constructor(
    private _domSanitizer: DomSanitizer,
    private _matIconRegistry: MatIconRegistry
  ) {
    // Register icon sets
    this._matIconRegistry.addSvgIconSet(
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/material-twotone.svg'
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'mat_outline',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/material-outline.svg'
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'mat_solid',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/material-solid.svg'
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'iconsmind',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/iconsmind.svg'
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'feather',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/feather.svg'
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_outline',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/heroicons-outline.svg'
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_solid',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/heroicons-solid.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'vacancy',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/vacancy.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'vacancy',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/vacancy.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'vacancy-list',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/vacancy-list.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'applicant',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/applicant.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'selected',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/selected-applicant.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'reserved',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/reserved-title.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'users-title',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/users-title.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'interface-lang',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/iterface-lang.svg'
      )
    );
    this._matIconRegistry.addSvgIcon(
      'info-icon',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/redesign-icons/info-icon.svg'
      )
    );
  }
}
